import timelineInit from "../components/_timeline.js";
import comparisonSliderInit from "../components/_comparison-slider.js";

timelineInit();
comparisonSliderInit();
